module.exports = __webpack_public_path__ + "img/p3.c1da74d1.png";